import React from "react";

const IconTrophy = ({ className, fill = false, duotone = true }) => {
  return (
    <>
      {!fill ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M7 2H17C18.1046 2 19 2.89543 19 4V6C19 7.10457 18.1046 8 17 8H16V10C16 11.1046 15.1046 12 14 12H10C8.89543 12 8 11.1046 8 10V8H7C5.89543 8 5 7.10457 5 6V4C5 2.89543 5.89543 2 7 2Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            opacity={duotone ? "0.5" : "1"}
            d="M9 12V20H15V12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            opacity={duotone ? "0.5" : "1"}
            d="M12 20V22"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            opacity={duotone ? "0.5" : "1"}
            d="M8 22H16"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 2H17C18.1046 2 19 2.89543 19 4V6C19 7.10457 18.1046 8 17 8H16V10C16 11.1046 15.1046 12 14 12H10C8.89543 12 8 11.1046 8 10V8H7C5.89543 8 5 7.10457 5 6V4C5 2.89543 5.89543 2 7 2ZM9 12V20H15V12H9Z"
            fill="currentColor"
          />
          <path
            opacity={duotone ? "0.5" : "1"}
            d="M12 20V22M8 22H16"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      )}
    </>
  );
};

export default IconTrophy;
